/* OSERE — iconos Lottie de los ingredientes.

   El reproductor pesa 45,6 KB comprimidos, así que NO se carga con la página:
   se pide la primera vez que un icono se acerca a la pantalla, y una sola vez
   para todos. `CLAUDE.md` pide «JS mínimo y defer, sin librerías pesadas», y
   esta es la forma de cumplirlo sin renunciar a la animación.

   Se elige `lottie_light` y no el completo (45,6 KB frente a 74,8) porque
   medido fotograma a fotograma —0, 10, 20, 30, 40 y 49 de 75— los dos dibujan
   EXACTAMENTE lo mismo con nuestros archivos. Las 114 expresiones que traen
   solo cableaban color y grosor desde una capa de control, y esos valores ya
   están horneados en las formas por el script de recoloreado.

   Regla de fallo: el marcador estático (símbolo, icono dibujado o GIF) se
   pinta SIEMPRE en el HTML. Este archivo solo lo sustituye si consigue cargar.
   Si no llega a ejecutarse, no se pierde nada. */
(function () {
  var cajas = document.querySelectorAll('[data-os-lottie]');
  if (!cajas.length || !('IntersectionObserver' in window)) return;

  var quieto = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  /* Datos ajenos: no se gastan 45 KB de librería más los JSON en una conexión
     que el usuario está pagando por megabyte. */
  var con = navigator.connection || {};
  var pobre = con.saveData === true || /^(slow-)?2g$/.test(con.effectiveType || '');
  if (pobre) return;

  var cargando = null;

  function reproductor() {
    if (cargando) return cargando;
    cargando = new Promise(function (ok, mal) {
      var s = document.createElement('script');
      s.src = cajas[0].getAttribute('data-os-lottie-player');
      s.onload = function () {
        ok(window.lottie);
      };
      s.onerror = mal;
      document.head.appendChild(s);
    });
    return cargando;
  }

  /* Lottie guarda el color como [r, g, b] en escala 0-1, no 0-255. Devolver
     0-255 aquí pinta todo blanco y no da error: es la misma trampa que el
     `color(srgb …)` del cotejo de contraste. */
  function aRgb(hex) {
    var h = String(hex).replace('#', '').trim();
    if (h.length === 3) h = h[0] + h[0] + h[1] + h[1] + h[2] + h[2];
    if (h.length !== 6) return null;
    return [
      parseInt(h.slice(0, 2), 16) / 255,
      parseInt(h.slice(2, 4), 16) / 255,
      parseInt(h.slice(4, 6), 16) / 255,
    ];
  }

  /* Recorre el árbol y reescribe TODO color de relleno o de trazo. La forma
     canónica es {"c": {"k": [r, g, b, a]}}; se conserva el alfa que hubiera,
     porque algunas capas lo usan para desvanecer. */
  function recolorear(nodo, rgb) {
    if (!rgb || !nodo || typeof nodo !== 'object') return;
    if (Array.isArray(nodo)) {
      for (var i = 0; i < nodo.length; i++) recolorear(nodo[i], rgb);
      return;
    }
    var c = nodo.c;
    if (c && Object.prototype.toString.call(c.k) === '[object Array]' && c.k.length >= 3 && typeof c.k[0] === 'number') {
      c.k[0] = rgb[0];
      c.k[1] = rgb[1];
      c.k[2] = rgb[2];
    }
    for (var clave in nodo) {
      if (Object.prototype.hasOwnProperty.call(nodo, clave)) recolorear(nodo[clave], rgb);
    }
  }

  function montar(caja) {
    reproductor()
      .then(function (lottie) {
        if (!lottie) return;
        var destino = document.createElement('span');
        destino.className = 'os-composicion__ing-lottie';
        caja.appendChild(destino);

        var ruta = caja.getAttribute('data-os-lottie');
        var tinta = caja.getAttribute('data-os-lottie-color');

        function arrancar(opciones) {
          var anim = lottie.loadAnimation(opciones);
          anim.addEventListener('DOMLoaded', function () {
          /* El marcador estático solo se retira cuando el Lottie ya está
             dibujado: así no hay un hueco entre que desaparece uno y aparece
             el otro. */
            caja.setAttribute('data-os-lottie-listo', 'true');
            if (quieto) anim.goToAndStop(0, true);
            else anim.play();
          });
        }

        var base = {
          container: destino,
          renderer: 'svg',
          loop: !quieto,
          autoplay: false,
        };

        /* Sin tinta pedida, se carga por ruta y el archivo manda: es el camino
           barato, sin fetch ni recorrido. */
        if (!tinta) {
          base.path = ruta;
          arrancar(base);
          return;
        }

        /* Con tinta pedida hay que traerse el JSON y reescribir sus colores,
           porque en Lottie el color va HORNEADO en cada capa: no es CSS y no
           hay `currentColor` que valga. Estos cuatro archivos traen dos —el
           rojo de marca y el negro verdoso—, que es lo que se veía como
           «rojo con verde o negro».

           Un filtro CSS no sirve: `hue-rotate` sobre un negro no da rojo, y
           `filter: url(#...)` obligaría a inyectar un SVG por icono. */
        fetch(ruta)
          .then(function (r) { return r.json(); })
          .then(function (datos) {
            recolorear(datos, aRgb(tinta));
            base.animationData = datos;
            arrancar(base);
          })
          .catch(function () {
            /* Si el fetch falla se pinta con sus colores originales antes que
               no pintar nada. */
            base.path = ruta;
            arrancar(base);
          });
      })
      .catch(function () {
        /* Se queda el marcador estático, que es el fallo correcto. */
      });
  }

  var observador = new IntersectionObserver(
    function (entradas) {
      entradas.forEach(function (e) {
        if (!e.isIntersecting) return;
        observador.unobserve(e.target);
        montar(e.target);
      });
    },
    { rootMargin: '300px' }
  );

  for (var i = 0; i < cajas.length; i++) observador.observe(cajas[i]);
})();
